module.exports = __webpack_public_path__ + "img/app-prev-eng.bafabfbf.png";